// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'format' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { format } from "date-fns";

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'DateFormat' is declared but its value is never re... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DateFormat } from "constants/date";
import { Filter, IFilters, TagFilter } from "constants/filters";
import { ReportDistribution } from "constants/reports/distribution";
import { ensureArray, ensureFlat } from "helpers/data";
import { IReportsViewFilters } from "store/views/reports";

interface ISerializedFilters {
  distribution?: ReportDistribution;
  date?: string;
  dateFrom?: string;
  dateTo?: string;
  agent?: string[];
  group?: string | string[];
  priority?: string[];
  priorityOp?: string;
  tag?: string[];
  tagged?: string;
  detailedSource?: string[];
  language?: string[];
}

export function serializeFilters(
  filters: IReportsViewFilters,
  distribution: ReportDistribution,
  comparison: (keyof IFilters)[] = []
): ISerializedFilters {
  const requestParams: ISerializedFilters = {
    distribution,
  };

  if (filters[Filter.DateRange]) {
    if (filters[Filter.DateRange].compare && comparison.includes(Filter.DateRange)) {
      requestParams.dateFrom = filters[Filter.DateRange].compare.from as string;
      requestParams.dateTo = filters[Filter.DateRange].compare.to as string;
    } else {
      requestParams.dateFrom = filters[Filter.DateRange].from as string;
      requestParams.dateTo = filters[Filter.DateRange].to as string;
    }
  }

  if (filters[Filter.Agent]) {
    if (filters[Filter.Agent].compare && comparison.includes(Filter.Agent)) {
      requestParams.agent = ensureArray(filters[Filter.Agent].compare);
    } else {
      // @ts-expect-error TS(2322)
      requestParams.agent = ensureArray(filters[Filter.Agent].agents);
    }
  }

  if (filters[Filter.Group]) {
    if (filters[Filter.Group].compare && comparison.includes(Filter.Group)) {
      const value = ensureArray(filters[Filter.Group].compare);

      requestParams.group = value.includes("MY_TEAMS") ? "MY_TEAMS" : value;
    } else {
      const value = ensureArray(filters[Filter.Group].groups);

      // @ts-expect-error TS(2322)
      requestParams.group = value.includes("MY_TEAMS") ? "MY_TEAMS" : value;
    }
  }

  if (filters[Filter.Tag] && filters[Filter.Tag].includes(TagFilter.NotTagged)) {
    requestParams.tagged = "0";
  }

  if (filters[Filter.Tag]) {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requestParams.tag = filters[Filter.Tag].filter((tag: any) => tag !== TagFilter.NotTagged);
  }

  if (filters[Filter.Priority]) {
    requestParams.priority = ensureArray(filters[Filter.Priority].priority).map(p => p.toString());
    if (filters[Filter.Priority].priorityOp) {
      requestParams.priorityOp = ensureFlat(filters[Filter.Priority].priorityOp);
    }
  }

  if (filters[Filter.DetailedSource]) {
    requestParams.detailedSource = ensureArray(filters[Filter.DetailedSource]);
  }

  if (filters[Filter.Language]) {
    requestParams.language = ensureArray(filters[Filter.Language]);
  }

  return requestParams;
}
